







































import Vue from 'vue'
import BatchTableHeader from '@/UI/Batch/BatchTableHeader.vue'
import BatchTableRow from '@/UI/Batch/BatchTableRow.vue'
import SpeciesResultasTable from '@/UI/Batch/Species/SpeciesResultasTable.vue'
import SpeciesRiscoTable from '@/UI/Batch/Species/SpeciesRiscoTable.vue'
import { BatchDto } from '@/Application/Batch'

export default Vue.extend({
  name: 'BatchTable',
  components: { SpeciesResultasTable, SpeciesRiscoTable, BatchTableHeader, BatchTableRow },
  props: {
    mode: {
      type: String,
      required: true,
      validator: (value: string): boolean => {
        return ['Risco', 'Resultas'].indexOf(value) !== -1
      }
    },
    batches: {
      type: Array as () => BatchDto[],
      required: true
    },
    checks: {
      type: Boolean,
      default: false,
      required: false
    },
    selectedChecks: {
      type: Array as () => string[],
      required: false
    },
    showFianza: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expandedRows: [] as number[],
      batchSelecteds: [] as string[]
    }
  },
  computed: {
    volumenUnit (): string {
      if (this.batches.length > 0) {
        return this.batches[0].volumeUnit
      } else return ''
    }
  },
  watch: {
    batchSelecteds (): void {
      this.sendSelecteds()
    }
  },
  mounted () {
    this.batchSelecteds = this.selectedChecks
  },
  methods: {
    onBatchrowToggledExpanded (expanded: boolean, index: number) {
      if (expanded) {
        this.expandedRows.push(index)
        return
      }
      const updatedIndexes = this.expandedRows.filter(current => current !== index)
      this.expandedRows = updatedIndexes
    },
    onUpdateSelecteds (selected: boolean, batchId: string) {
      const updatedSelectedBatches = [...this.batchSelecteds]
      if (selected) {
        updatedSelectedBatches.push(batchId)
      } else {
        const indexFound = updatedSelectedBatches.findIndex(element => element === batchId)
        if (indexFound !== -1) {
          updatedSelectedBatches.splice(indexFound, 1)
        }
      }
      this.batchSelecteds = updatedSelectedBatches
    },
    sendSelecteds () {
      this.$emit('batchSelecteds', this.batchSelecteds)
    }
  }
})
